import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { sidebarMenu_template } from "./sidebarMenu_template";


declare var ko: any;

export class customDimensions_template extends vnTemplate {

    protected searchField: filterSimple_template;
    public sidebarMenu: sidebarMenu_template;

    protected buildViewModel() {

        let self = this;

        return {
            customDimensions: ko.observable([]),
            selectedDimension: ko.observable(null),

            edit_dimensionName: ko.observable(''),
            edit_description: ko.observable(''),

            create_dimensionName: ko.observable(''),
            create_description: ko.observable(''),

            isCreateOpen: ko.observable(false),
            isEditOpen: ko.observable(false),

            showMaxPopup: ko.observable(false),

            nameError: ko.observable(null),
            descriptionError: ko.observable(null),
            generalError: ko.observable(null),

            onCloseMaxPopup: function() {

                self.onCloseMaxPopup();
            },
            openSidebar: function() {

                self.openSidebar();
            },
            onOpenCreate: function() {

                self.onOpenCreate();
            },
            onOpenEdit: function(dimension){

                self.onOpenEdit(dimension);
            },
            onCloseCreate: function(){

                self.onCloseCreate();
            },
            onCloseEdit: function(){

                self.onCloseEdit();
            },
            onSubmitEdit(){
                self.onSubmitEdit();
            },
            onSubmitCreate(){
                self.onSubmitCreate();
            },
            disabledCreate(){

                return self.disabledCreate();
            },
            disabledEdit(){

                return self.disabledEdit();
            },
            getStatusString: function(statusId) {

               return self.getStatusString(statusId);
            }
        }

    }

    public setSideMenuPermissionsData(data){

        this.sidebarMenu.setData(data);
    }

    private openSidebar(){

        this.sidebarMenu.setSidebarToggle(true);
    }

    protected getTemplateName(): string {

        return 'customDimensions_template';
    }

    public onCloseMaxPopup(){

        this.getTemplateViewModel().showMaxPopup(false);
        this.clearErrors();
    }

    public onSubmitEdit() {

        this.caller.onSubmitEdit();
    }

    public onSubmitCreate(){

        this.caller.onSubmitCreate();
    }


    protected getMainElementClasses(): Array<string>{
        return ["page-content"];
    }


    public setCustomDimensions(customDimensions){

        this.getTemplateViewModel().customDimensions(customDimensions);
    }

    public onOpenCreate() {

        if (this.getTemplateViewModel().customDimensions().length >= 25) {

            this.getTemplateViewModel().showMaxPopup(true);
        } else {

            this.getTemplateViewModel().isCreateOpen(true);
        }
    }

    public onOpenEdit(dimension) {

        this.getTemplateViewModel().selectedDimension(dimension);
        this.getTemplateViewModel().edit_dimensionName(dimension.dimensionName);
        this.getTemplateViewModel().edit_description(dimension.description);
        this.getTemplateViewModel().isEditOpen(true);
    }

    public onCloseCreate(){

        this.getTemplateViewModel().create_dimensionName('');
        this.getTemplateViewModel().create_description('');
        this.getTemplateViewModel().isCreateOpen(false);
        this.clearErrors();
    }

    public onCloseEdit(){

        this.getTemplateViewModel().selectedDimension(null);
        this.getTemplateViewModel().isEditOpen(false);
        this.clearErrors();
    }

    public clearErrors(){

        this.getTemplateViewModel().generalError(null);
        this.getTemplateViewModel().nameError(null);
        this.getTemplateViewModel().descriptionError(null);
    }

    public disabledCreate() {

        const name = this.getTemplateViewModel().create_dimensionName();

        return (!name || name == '');
    }

    public disabledEdit() {

        const name = this.getTemplateViewModel().edit_dimensionName();

        return (!name || name == '');
    }

    protected getTemplateHtml(): string {
        return `
            <div class="page-header">
                <button data-bind="event: { click: openSidebar }" class="button-default no-text icon i-hamburger preferences no-after"></button>
                <h2 style="display: none;" class="title-page">Custom Dimensions</h2>
            </div>

            <div class="nav-page-container">
                <div class="nav-page-grid">

                    <div class="nav-page-sidebar">
                        ` + this.sidebarMenu.getHtmlBuild() + `
                    </div>

                    <div id="customDimensions-results" class="nav-page-content">

                        <div class="block-default variation">
                            <div class="w-justify full-width">
                                <div class="w-left w-form">
                                    <div class="form-body form-body-header">
                                        <div class="form-group">
                                            <span class="form-sub-title">
                                                Custom Dimensions Page
                                            </span>
                                        </div>
                                        <div class="form-group">
                                            <p class="form-text">
                                                Allowed characters: letters, numbers, spaces, dashes (-), and underscores (_).
                                            </p>
                                        </div>
                                        <div class="form-group">
                                            <hr class="form-hr">
                                        </div>
                                        <div class="form-group">
                                            <p class="form-text">
                                                <strong>Important:</strong>
                                            </p>
                                            <ul class="form-list">
                                                <li>A custom dimension cannot be deleted.</li>
                                                <li>Your account allows a maximum of 25 custom dimensions.</li>
                                                <li>Ensure each dimension is necessary before creating it.</li>
                                            </ul>
                                        </div>
                                        <div class="form-group frame">
                                            <p class="form-text">
                                                Once created, see your updated tracking code in <a href="/account_settings">Account Details</a>.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-right">

                                </div>
                            </div>
                        </div>

                        <div class="list-results-header w-justify">
                            <div class="w-left">
                               <button type="button" data-bind="click: onOpenCreate" class="button-default icon i-add-2"><span>Add Dimension</span></button>
                            </div>

                            <div class="w-center">
                                `+ this.searchField.getHtmlBuild() + `
                            </div>

                            <div class="w-right">

                            </div>
                        </div>

                        <div class="w-list-results taller">
                            <table class="list-results list-sections">
                                <thead>
                                    <tr>
                                        <th><span>Dimension Name</span></th>
                                        <th><span>Description</span></th>
                                        <th><span>Status</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- ko foreach: customDimensions() -->
                                    <tr class="cursor" data-bind="click: function() { $parent.onOpenEdit($data) }">
                                        <td><span data-bind="text: $data.dimensionName"></span></td>
                                        <td><span data-bind="text: $data.description"></span></td>
                                        <td><span data-bind="text: $parent.getStatusString($data.isActive)"></span></td>
                                    </tr>
                                    <!-- /ko -->
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>

            <div class="w-lightbox light-theme" data-bind="css: {'is-visible' : isCreateOpen()}">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Create custom dimension</h3>
                            <button type="button" data-bind="event: { click: onCloseCreate }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group" data-bind="css: {'is-error' : nameError()}">
                                <label class="form-label">Name</label>
                                <div class="w-input">
                                    <input data-bind="value: create_dimensionName" type="text" name="name" id="name" class="input-text" data-bind="value: name">
                                </div>
                                <span class="form-error" data-bind="text: nameError()"></span>
                            </div>

                            <div class="form-group" data-bind="css: {'is-error' : descriptionError()}">
                                <label class="form-label">Description</label>
                                <div class="w-input">
                                    <input data-bind="value: create_description" type="text" name="description" id="description" class="input-text">
                                </div>
                                <span class="form-error" data-bind="text: descriptionError()"></span>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button data-bind="click: onCloseCreate" type="button" class="btn">Cancel</button>
                            <button data-bind="click: onSubmitCreate, disable: disabledCreate()" type="button" class="btn highlight">Add</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ko if: selectedDimension -->
                <div class="w-lightbox light-theme" data-bind="css: {'is-visible' : isEditOpen() && selectedDimension()}">
                    <div class="lightbox-content">

                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Edit dimension</h3>
                                <button type="button" data-bind="event: { click: onCloseEdit }" class="close-button icon i-close-2"></button>
                            </div>

                            <div class="form-body">
                                <div class="form-group" data-bind="css: {'is-error' : nameError()}">
                                    <label class="form-label">Name</label>
                                    <div class="w-input">
                                        <input data-bind="value: edit_dimensionName" type="text" name="name" id="name" class="input-text">
                                    </div>
                                    <span class="form-error" data-bind="text: nameError()"></span>
                                </div>
                                <div class="form-group" data-bind="css: {'is-error' : descriptionError()}">
                                    <label class="form-label">Description</label>
                                    <div class="w-input">
                                        <input data-bind="value: edit_description" type="text" name="description" id="description" class="input-text">
                                    </div>
                                    <span class="form-error" data-bind="text: descriptionError()"></span>
                                </div>
                            </div>

                            <div class="form-footer">
                                <button data-bind="click: onCloseEdit" type="button" class="btn">Cancel</button>
                                <button data-bind="click: onSubmitEdit, disable: disabledEdit()" type="button" class="btn highlight">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            <!-- /ko -->

            <div class="w-lightbox light-theme center" data-bind="css: { 'is-visible' : showMaxPopup() }">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Create custom dimension</h3>
                            <button type="button" data-bind="event: { click: onCloseMaxPopup }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">You've reached the maximum number of dimensions you can create.</p>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button data-bind="event: { click: onCloseMaxPopup }" type="button" class="btn highlight">Ok</button>
                        </div>
                    </div>

                </div>
            </div>
            <footer class="default-footer">
                <span class="logo-short"></span>
                <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
                <span>|</span>
                <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
            </footer>

        `;
    }

    public getViewModelForRequest() {

        return {

            filters:{

                dimensionId: this.getTemplateViewModel().selectedDimension()?.dimension,
                create_dimensionName: this.getTemplateViewModel().create_dimensionName(),
                create_description: this.getTemplateViewModel().create_description(),
                edit_dimensionName: this.getTemplateViewModel().edit_dimensionName(),
                edit_description: this.getTemplateViewModel().edit_description(),
                search: this.getTemplateViewModel().searchField.filterKeyword()
            }
        }
    }

    public getStatusString(statusId){

        switch(statusId){

            case 1: {
                return "Active";
            }
            case 0: {
                return "Inactive";
            }
            default: {
                return "inactive"
            }
        }
    }

    protected initPartial() {

        this.sidebarMenu = new sidebarMenu_template("sidebarMenu", this.getTemplateViewModel(), this.caller);
        this.sidebarMenu.setPageSelected('custom-dimensions');

        this.searchField = new filterSimple_template("searchField", this.getTemplateViewModel(), this.caller);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/customDimensions_template.ts